"use strict";
var __importStar =
  (this && this.__importStar) ||
  function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null)
      for (var k in mod)
        if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
  };
Object.defineProperty(exports, "__esModule", { value: true });
const IValidation_1 = require("./IValidation");
const Yup = __importStar(require("yup"));
const helper_1 = require("./helper");
//todo define proper type.
const addonSchema = Yup.array()
  .of(
    Yup.object().shape({
      service: Yup.string().required(),
      method: Yup.string().required(),
      displayName: Yup.string().required(),
      isDependent: Yup.boolean().required(),
      addOns: Yup.array().of(Yup.lazy(() => addonSchema.default(undefined))),
      params: Yup.object().required()
    })
  )
  .test("addOn", "addOns is required", function(value) {
    return Array.isArray(value);
  });
const resourceSchema = Yup.object().shape({
  service: Yup.string().required("Please select one service"),
  method: Yup.string().required("Please select one resource"),
  addOns: addonSchema,
  params: Yup.object().required()
});
class ResourceNodeValidation {
  validate(node) {
    let data = node.getNodeData();
    // console.log( resourceSchema.validateSync(data));
    return helper_1.isValid(
      [
        { schema: resourceSchema, data },
        { schema: IValidation_1.nodeSchema, data: node.serializeNode() }
      ],
      node.getNodeId()
    );
  }
}
exports.ResourceNodeValidation = ResourceNodeValidation;
//# sourceMappingURL=ResourceNodeValidation.js.map
